import React from 'react'
import VoiceTalent from './../VoiceTalent'

const VoiceTalentMulti = (props) => (
  <VoiceTalent isMulti {...props} />
)
export default VoiceTalentMulti
